import React, { useEffect, forwardRef, Fragment } from 'react'
import Skeleton from '@mui/material/Skeleton'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import clsx from 'clsx'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import PageData from '@v4/utils/data/PageData'
import PropTypes from 'prop-types'
import useStyles from './Fallback.styled'

const Fallback = forwardRef(({ withEvent }, ref) => {
	const pageType = PageBuilderSelector.useType()
	const isTypeResultPdf = PageData.isTypeResultPdf(pageType)
	const classes = useStyles({
		isTypeResultPdf,
	})
	const columnSize = isTypeResultPdf ? 12 : 6

	useEffect(() => {
		if (!withEvent) {
			return undefined
		}
		return () => {
			const event = new Event('lazy-loaded')

			window.dispatchEvent(event)
		}
	}, [withEvent])

	const Wrapper = isTypeResultPdf ? Fragment : Container

	return (
		<div ref={ref} className={classes.root}>
			<Wrapper>
				<Grid container spacing={8} alignItems="center">
					<Grid
						size={{
							lg: columnSize,
							md: columnSize,
							sm: columnSize,
							xs: 12,
						}}
					>
						<div>
							<Box>
								<Skeleton
									className={classes.skeleton}
									animation="wave"
									variant="rectangular"
									width="50%"
									height="2.5rem"
								/>
							</Box>
							<Box mt={3}>
								<Skeleton
									className={classes.skeleton}
									animation="wave"
									variant="rectangular"
									height="1.5rem"
								/>
							</Box>
							<Box mt={3}>
								<Skeleton
									className={classes.skeleton}
									animation="wave"
									variant="rectangular"
									height="1rem"
								/>
							</Box>
							<Box mt={2}>
								<Skeleton
									className={classes.skeleton}
									animation="wave"
									variant="rectangular"
									height="1rem"
								/>
							</Box>
							<Box mt={2}>
								<Skeleton
									className={classes.skeleton}
									animation="wave"
									variant="rectangular"
									width="50%"
									height="1rem"
								/>
							</Box>
							{!isTypeResultPdf && (
								<>
									<Box mt={3}>
										<Skeleton
											className={classes.skeleton}
											animation="wave"
											variant="rectangular"
											height="1rem"
										/>
									</Box>
									<Box mt={2}>
										<Skeleton
											className={classes.skeleton}
											animation="wave"
											variant="rectangular"
											width="50%"
											height="1rem"
										/>
									</Box>
									<Box mt={3}>
										<Skeleton
											className={classes.skeleton}
											animation="wave"
											variant="rectangular"
											width="25%"
											height="2.5rem"
										/>
									</Box>
								</>
							)}
						</div>
					</Grid>
					<Grid
						size={{
							lg: columnSize,
							md: columnSize,
							sm: columnSize,
							xs: 12,
						}}
					>
						<div className={classes.rectWrap}>
							<Skeleton
								animation="wave"
								className={clsx(classes.skeleton, classes.rect)}
								variant="rectangular"
							/>
						</div>
					</Grid>
				</Grid>
			</Wrapper>
		</div>
	)
})

Fallback.propTypes = {
	withEvent: PropTypes.bool,
}

export default Fallback
